









































































import { Component, Vue } from 'vue-property-decorator';
import { i18n } from '@/plugins/i18n/i18n';
import { ErrorCode, ErrorInfo } from '@/types/type';

@Component({
  name: 'ErrorBoundary',
})
export default class ErrorBoundary extends Vue {
  private dialog: boolean = false;
  private occurredTime: string = '';
  private code: ErrorCode | null = null;
  private title: string | null = null;
  private args: string | null = null;
  private message: string | null = null;
  private stack: string | null = null;
  private info: string | null = null;

  private get literals() {
    return {
      close: i18n.tc('common.close'),
      title: i18n.tc('errorBoundary.title'),
      occurredTime: i18n.tc('errorBoundary.occurredTime'),
      errorCode: i18n.tc('errorBoundary.errorCode'),
      errorTitle: i18n.tc('errorBoundary.errorTitle'),
      argsInfo: i18n.tc('errorBoundary.argsInfo'),
      errorMessage: i18n.tc('errorBoundary.errorMessage'),
      stackInfo: i18n.tc('errorBoundary.stackInfo'),
      errorInfo: i18n.tc('errorBoundary.errorInfo'),
    };
  }

  public errorCaptured(error: Error, _: Vue.Component, info: string): void {
    this.dialog = true;
    this.occurredTime = new Date().toUTCString();
    try {
      const errorInfo: ErrorInfo = JSON.parse(error.message);
      this.code = errorInfo.code || null;
      this.title = errorInfo.title || null;
      this.args = errorInfo.args ? JSON.stringify(errorInfo.args) : null;
      this.message = errorInfo.message || null;
    } catch (e) {
      this.message = error.message;
    }
    this.stack = error.stack || null;
    this.info = info;
  }
}
